<div mat-dialog-container>
  @if (organisation) {
    <form #netzbetreiberForm="ngForm">
      <div mat-dialog-title style="display: flex; flex-direction: row;">
        <div class="dialog-header" fxFlex fxLayout="end">Kontaktdaten - {{ organisation?.name }}</div>
        <div class="close" style="margin-left: auto;">
          <button data-qa="kontaktdaten-dialog-close-button" (click)="cancel()" type="button"
                  color="primary" matMiniFab>
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
          </button>
        </div>
      </div>
      <div mat-dialog-content>
        <div style="padding-bottom: 20px">
          <h3>Ihre bei uns fest hinterlegten Informationen:</h3>
          <dl>
            <dt>Stromnetzbetreibernummer</dt>
            <dd>
              {{ organisation.stromNetzbetreiberNummer }}
            </dd>
            <dt>EIC Nummer</dt>
            <dd data-qa="contact-eic-value">{{ organisation.eicNummer }}</dd>
            @if (organisation.eicNummer2 !== undefined && organisation.eicNummer2 !== '') {
              <dt>EIC Nummer 2</dt>
            }
            @if (organisation.eicNummer2 !== undefined && organisation.eicNummer2 !== '') {
              <dd
              >{{ organisation.eicNummer2 }}
              </dd>
            }
            @if (organisation.eicNummer3 !== undefined && organisation.eicNummer3 !== '') {
              <dt>EIC Nummer 3</dt>
            }
            @if (organisation.eicNummer3 !== undefined && organisation.eicNummer3 !== '') {
              <dd
              >{{ organisation.eicNummer3 }}
              </dd>
            }
            @if (organisation.eicNummerNvnbs !== undefined && organisation.eicNummerNvnbs?.join(', ') !== '') {
              <dt>EIC
                nnVNB
              </dt>
            }
            @if (organisation.eicNummerNvnbs !== undefined && organisation.eicNummerNvnbs?.join(', ') !== '') {
              <dd
              >{{ organisation.eicNummerNvnbs }}
              </dd>
            }
          </dl>
        </div>
        <div style="padding-bottom: 20px">
          <h3>Ihre Kontaktdaten:</h3>
          An diese E-Mail-Adressen werden Erinnerungen verschickt, wenn zum Beispiel ein neuer Vorgang angelegt wurden
          oder die Frist eines noch offenen Vorgangs fast erreicht ist.<br>
          Hier können mehrere E-Mail-Adressen durch Komma getrennt eingetragen werden.
        </div>
        <mat-form-field style="width: 100%;">
          <mat-label>Email Adressen, mit Komma getrennt</mat-label>
          <input matInput [uflaValidEmailList]="" [(ngModel)]="organisation.emailAdressen"
                 #emailAdressen="ngModel" name="emailAdressen"/>
          @if (emailAdressen?.errors?.validEmailList) {
            <mat-error>
              Die Emailadressen müssen gültig sein.
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div mat-dialog-actions align="end">
        <div fxFlex fxLayoutAlign="end" fxLayoutGap="1rem">
          <button matButton="outlined" data-qa="close-details-button" type="button" (click)="cancel()">
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
            Abbrechen
          </button>
          <button matButton="filled" data-qa="save-details-button"
                  type="button"
                  [disabled]="!netzbetreiberForm.valid || netzbetreiberForm.pristine"
                  (click)="updateEmail()">
            <mat-icon>save</mat-icon>
            Speichern
          </button>
        </div>
      </div>
    </form>
  }

  <ng-template #errorDialog>
    <h2 matDialogTitle>
      <mat-icon color='warn'>error</mat-icon>
      Fehler
    </h2>
    <p matDialogContent><em>Änderungen konnten nicht gespeichert werden!</em></p>
    <mat-dialog-actions align="end">
      <button matButton="filled" matDialogClose>
        <mat-icon svgIcon="innogy_picto_check">
        </mat-icon>
        Verstanden
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>
